import { ValidationResult } from "./validation-result";

export class SaidValidator {


  constructor() { }

  /** Check if the ID consists of exactly 13 numeric digits */




isNumeric13(id: string): boolean {
  return /^\d{13}$/.test(id);
}


parseDOBFromID(id: string, now = new Date()): Date | null {
  if (!/^\d{6}/.test(id)) return null;
  const yy = parseInt(id.slice(0, 2), 10);
  const mm = parseInt(id.slice(2, 4), 10);
  const dd = parseInt(id.slice(4, 6), 10);

  const currentYear = now.getFullYear();
  const currentYY = currentYear % 100;

 
  const century = (yy <= currentYY) ? 2000 : 1900;
  const fullYear = century + yy;

  const date = new Date(fullYear, mm - 1, dd);
  if (
    date.getFullYear() !== fullYear ||
    date.getMonth() !== mm - 1 ||
    date.getDate() !== dd
  ) {
    return null;
  }
  return date;
}


luhnCheck(id: string): boolean {
  if (!/^[0-9]+$/.test(id)) return false;
  const digits = id.split('').map(d => parseInt(d, 10));
  let sum = 0;

  const len = digits.length;
  for (let i = len - 1, pos = 0; i >= 0; i--, pos++) {
    let d = digits[i];
    if (pos % 2 === 1) { 
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
  }
  return sum % 10 === 0;
}

computeAge(dob: Date, now = new Date()): number {
  let age = now.getFullYear() - dob.getFullYear();
  const m = now.getMonth() - dob.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) {
    age--;
  }
  return age;
}

/** Main validator — checks ID and whether under the given age (default 14)
 * Returns a structured ValidationResult
 */
 isUnderAge(id: string, threshold = 14, now = new Date()): ValidationResult {

  if(id == undefined || id==null){
    return { ok: false, reasons: ['ID is null or undefined'] };
  }
  const reasons: string[] = [];
  const clean = (id || '').trim();

  if (!this.isNumeric13(clean)) {
    reasons.push('ID must be exactly 13 numeric digits');
    return { ok: false, reasons };
  }

  const dob = this.parseDOBFromID(clean, now);
  if (!dob) {
    reasons.push('Invalid date of birth encoded in ID (bad YYMMDD)');
  }

  if (!this.luhnCheck(clean)) {
    reasons.push('Failed Luhn checksum');
  }

  // Optional: validate citizenship digit (position 11; index 10) is 0 or 1
  const citizenshipDigit = clean.charAt(10);
  if (!/[01]/.test(citizenshipDigit)) {
    // Some older/newer IDs may use differing conventions but 0/1 is standard for SA IDs
    reasons.push('Unexpected citizenship digit (expected 0 or 1 at position 11)');
  }

  if (reasons.length > 0) {
    return { ok: false, reasons };
  }

  // At this point ID has passed format, DOB parse, Luhn, and citizenship check
  const age = this.computeAge(dob!, now);
  const under = age < threshold;
  return {
    ok: true,
    reasons: [],
    dob: dob!.toISOString().slice(0, 10),
    age,
    isUnderAge: under,
  };
}

}
